"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpendableInUsGallons = exports.ExpendableInHours = exports.ExpendableInLiters = exports.DepletableInKilograms = exports.DepletableInLiters = exports.DepletableInGrams = exports.Expendable = exports.Depletable = exports.Fields = exports.Name = exports.Id = exports.ExpendableState = exports.DepletableState = exports.hasBatch = exports.BatchState = exports.isExpirable = exports.ExpirableState = exports.BaseState = exports.Category = void 0;
exports.satisfiesConstructor = satisfiesConstructor;
const effect_1 = require("effect");
const date_1 = require("../../../../../date");
const Unit = __importStar(require("../../../../../unit"));
const NAMESPACE = 'Culligan.Device.Capability.Consumable.Definition';
exports.Category = {
    CO2Tank: 'CO2 Tank',
    Enhancements: 'Enhancements',
    Filter: 'Filter',
    UVLamp: 'UV Lamp',
};
/**
 * The body of this function is intentionally empty:
 * It only serves to check whether a consumable definition class satisfies
 * the {@link Constructor} `interface` and the constraints around its generics
 */
function satisfiesConstructor(_ctor) {
    /* intentional: compile-time type assertion only */
}
exports.BaseState = effect_1.Schema.Struct({
    installedAt: effect_1.Schema.propertySignature(date_1.ValidDateFromNumber).annotations({
        title: 'Installation Date',
        description: 'The date and time at which the consumable instance was installed to the unit',
    }),
    recalled: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true, default: () => false }).annotations({
        title: 'Recall Status',
        description: 'Whether the consumable has been recalled, and should not be used',
    }),
}).annotations({ identifier: `${NAMESPACE}.BaseState` });
exports.ExpirableState = effect_1.Schema.Struct({
    expiresAt: effect_1.Schema.propertySignature(date_1.ValidDateFromNumber).annotations({
        title: 'Expiry Date',
        description: 'The date (and time) at which the consumable is due to expire',
    }),
}).annotations({ identifier: `${NAMESPACE}.ExpirableState` });
exports.isExpirable = effect_1.Schema.is(exports.ExpirableState);
exports.BatchState = effect_1.Schema.Struct({ batch: effect_1.Schema.NonEmptyString }).annotations({
    identifier: `${NAMESPACE}.BatchState`,
});
exports.hasBatch = effect_1.Schema.is(exports.BatchState);
exports.DepletableState = effect_1.Schema.Struct({
    level: effect_1.Schema.propertySignature(effect_1.Schema.NonNegative).annotations({
        title: 'Remaining Level',
        description: 'Number of units left in the consumable; when 0 is reached, ' +
            'there is nothing left. Note that unit of measure is implied ' +
            'to be the unit of measure used in the definition of the "range" ' +
            'properties of the corresponding consumable.',
    }),
}).annotations({
    identifier: `${NAMESPACE}.DepletableState`,
    description: 'The state of your depletable consumable',
});
exports.ExpendableState = effect_1.Schema.Struct({
    usage: effect_1.Schema.propertySignature(effect_1.Schema.NonNegative).annotations({
        title: 'Total Usage',
        description: 'Number of units of the consumable that were used; can exceed the' +
            'limits. Note that unit of measure is implied to be the unit of ' +
            'measure used in the definition of the "range" properties of ' +
            'the corresponding consumable.',
    }),
}).annotations({
    identifier: `${NAMESPACE}.ExpendableState`,
    description: 'The state of your expendable consumable',
});
const makeDepletable = (uomSchema) => effect_1.Schema.Struct({ rangeFullCapacity: uomSchema, rangeTrigger: uomSchema, rangeExhaust: uomSchema }).pipe(effect_1.Schema.filter(({ rangeExhaust, rangeFullCapacity }) => rangeExhaust.amount < rangeFullCapacity.amount || {
    path: ['rangeExhaust', 'amount'],
    message: 'must be below the full capacity value',
}, { jsonSchema: {} }), effect_1.Schema.filter(({ rangeTrigger, rangeFullCapacity }) => rangeTrigger.amount < rangeFullCapacity.amount || {
    path: ['rangeTrigger', 'amount'],
    message: 'must be below the full capacity value',
}, { jsonSchema: {} }), effect_1.Schema.filter(({ rangeTrigger, rangeExhaust }) => rangeTrigger.amount > rangeExhaust.amount || {
    path: ['rangeTrigger', 'amount'],
    message: 'must be above the exhaust value',
}, { jsonSchema: {} }));
const makeExpendable = (uomSchema) => effect_1.Schema.Struct({ rangeTrigger: uomSchema, rangeExhaust: uomSchema }).pipe(effect_1.Schema.filter(({ rangeTrigger, rangeExhaust }) => rangeTrigger.amount < rangeExhaust.amount || {
    path: ['rangeTrigger', 'amount'],
    message: 'must be below the exhaust value',
}, { jsonSchema: {} }));
exports.Id = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${NAMESPACE}.Id`,
    title: 'Consumable Definition Identifier',
});
exports.Name = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${NAMESPACE}.Name`,
    title: 'Consumable Definition Name',
});
exports.Fields = { id: exports.Id, name: exports.Name };
class Depletable extends effect_1.Schema.Class(`${NAMESPACE}.Depletable`)({}) {
    depletable = true;
    expendable = false;
}
exports.Depletable = Depletable;
class Expendable extends effect_1.Schema.Class(`${NAMESPACE}.Expendable`)({}) {
    depletable = false;
    expendable = true;
}
exports.Expendable = Expendable;
class DepletableInGrams extends Depletable.extend(`${NAMESPACE}.DepletableInGrams`)(makeDepletable(Unit.Mass.Gram)) {
}
exports.DepletableInGrams = DepletableInGrams;
class DepletableInLiters extends Depletable.extend(`${NAMESPACE}.DepletableInLiters`)(makeDepletable(Unit.Volume.Liter)) {
}
exports.DepletableInLiters = DepletableInLiters;
class DepletableInKilograms extends Depletable.extend(`${NAMESPACE}.DepletableInKilograms`)(makeDepletable(Unit.Mass.Kilogram)) {
}
exports.DepletableInKilograms = DepletableInKilograms;
class ExpendableInLiters extends Expendable.extend(`${NAMESPACE}.ExpendableInLiters`)(makeExpendable(Unit.Volume.Liter)) {
}
exports.ExpendableInLiters = ExpendableInLiters;
class ExpendableInHours extends Expendable.extend(`${NAMESPACE}.ExpendableInHours`)(makeExpendable(Unit.Time.Hour)) {
}
exports.ExpendableInHours = ExpendableInHours;
class ExpendableInUsGallons extends Expendable.extend(`${NAMESPACE}.ExpendableInUsGallons`)(makeExpendable(Unit.Volume.UsGallon)) {
}
exports.ExpendableInUsGallons = ExpendableInUsGallons;
//# sourceMappingURL=common.js.map